import './style.scss';
import { inViewAnimations } from "../../scripts/InViewAnimations";


export function all_resources_block() {
    const block = document.querySelector('.all_resources_block');
    if (!block) return;

    const POSTS_PER_PAGE = 20; // Configured in PHP

    const ajaxUrl = block.getAttribute('data-ajax-url');
    const nonce = block.getAttribute('data-nonce');
    const filterBtns = block.querySelectorAll('.filter-btn');
    const grid = block.querySelector('.resources-grid');
    const loadMoreBtnWrapper = block.querySelector('.load-more-wrapper');
    const loadMoreBtn = block.querySelector('.load-more-btn');

    let page = 1;
    let currentTerm = 'all';
    let isLoading = false;

    const getLoadMoreBtn = () => block.querySelector('.load-more-btn');
    const getLoadMoreWrapper = () => block.querySelector('.load-more-wrapper');

    const setLoading = (loading, type = 'loadMore') => {
        isLoading = loading;
        const btn = getLoadMoreBtn();

        if (loading) {
            if (type === 'loadMore' && btn) {
                btn.classList.add('loading');
                btn.innerHTML = 'Loading...';
            } else if (type === 'filter') {
                if (grid) grid.style.opacity = '0.9';
            }
        } else {
            // Reset all states
            if (btn) {
                btn.classList.remove('loading');
                btn.innerHTML = `Load More
                    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 7.4L0 1.4L1.4 0L6 4.575L10.6 0L12 1.4L6 7.4Z" fill="white" />
                    </svg>`;
            }
            if (grid) grid.style.opacity = '1';
        }
    };

    const loadPosts = (reset = false) => {
        if (isLoading) return;
        setLoading(true, reset ? 'filter' : 'loadMore');

        const formData = new FormData();
        formData.append('action', 'load_more_resources');
        formData.append('nonce', nonce);
        formData.append('page', reset ? 1 : page + 1);
        formData.append('term_slug', currentTerm);
        formData.append('posts_per_page', POSTS_PER_PAGE);

        fetch(ajaxUrl, {
            method: 'POST',
            body: formData
        })
            .then(response => response.json())
            .then(res => {
                if (res.success) {
                    const html = res.data.html;
                    const hasMore = res.data.has_more;
                    const wrapper = getLoadMoreWrapper();

                    if (reset) {
                        grid.innerHTML = html;
                        page = 1;

                        if (html.trim() === '') {
                            grid.innerHTML = '<p>No resources found.</p>';
                        } else {
                            inViewAnimations(grid);
                        }

                        if (wrapper) {
                            wrapper.style.display = hasMore ? 'flex' : 'none';
                        }

                    } else {
                        // Append
                        if (html.trim() !== '') {
                            const tempDiv = document.createElement('div');
                            tempDiv.innerHTML = html;
                            const newElements = Array.from(tempDiv.querySelectorAll('.resource-item'));

                            newElements.forEach(el => grid.appendChild(el));
                            page++;

                            // Animate ONLY new elements
                            inViewAnimations(newElements);
                        }

                        if (wrapper) {
                            wrapper.style.display = hasMore ? 'flex' : 'none';
                        }
                    }
                }
            })
            .catch(err => console.error(err))
            .finally(() => {
                setLoading(false);
            });

    };

    // Filter Click
    filterBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            // Update UI
            filterBtns.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');

            currentTerm = btn.getAttribute('data-filter');
            loadPosts(true);
        });
    });

    // Load More Click
    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', (e) => {
            e.preventDefault();
            loadPosts(false);
        });
    }
}
